import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shared--reveal"
// Shows elements hidden with the "hidden" class, e.g. from a "Details" link:
//   %a{ href: "#", data: { controller: "shared--reveal", action: "shared--reveal#toggle",
//     "shared--reveal-selector-value": ".details", "shared--reveal-scope-value": ".info-box" } }
// selector: the elements to show, searched within the closest scope ancestor
// (the whole document without one).
export default class extends Controller {
  static values = { selector: String, scope: String };

  // Shows or hides the elements on every click
  toggle(event) {
    event.preventDefault();
    this.elements().forEach((element) => element.classList.toggle("hidden"));
  }

  // Shows the elements once and hides the trigger itself
  reveal(event) {
    event.preventDefault();
    this.elements().forEach((element) => element.classList.remove("hidden"));
    this.element.classList.add("hidden");
  }

  elements() {
    const root =
      (this.scopeValue && this.element.closest(this.scopeValue)) || document;
    return root.querySelectorAll(this.selectorValue);
  }
}
